import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentCancelledPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#E8E4DF] flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-2xl p-8 text-center">
        <div className="text-gray-600 text-6xl mb-4">✕</div>
        <h2 
          className="text-2xl mb-2 text-gray-800"
          style={{ fontFamily: 'IBM Plex Serif, serif' }}
        >
          Payment Cancelled
        </h2>
        <p 
          className="text-gray-600 mb-6"
          style={{ fontFamily: 'IBM Plex Serif, serif' }}
        >
          Your payment was cancelled. No charges were made to your account.
        </p>
        <div className="space-y-3">
          <button
            onClick={() => navigate('/payment')}
            className="w-full bg-gray-800 text-white px-6 py-3 rounded-full hover:bg-gray-700 transition-all"
            style={{ fontFamily: 'IBM Plex Serif, serif' }}
          >
            Try Again
          </button>
          <button
            onClick={() => navigate('/')}
            className="w-full border border-gray-800 text-gray-800 px-6 py-3 rounded-full hover:bg-gray-100 transition-all"
            style={{ fontFamily: 'IBM Plex Serif, serif' }}
          >
            Return Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelledPage;
